export function dateIsInPast(ISODateString: string) {
  const dateInMs = new Date(ISODateString).getTime()
  const currentDateInMs = new Date().getTime()
  return dateInMs < currentDateInMs
}
